module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("04zKh"))).then(() => parcelRequire('d0iPb'));